import React from 'react';
import PropTypes from 'prop-types';

import InfoTable from "../settings/InfoTable";

import BondType from "./BondType";


import TextDate from "components/text/TextDate";
import TextBoolean from "components/text/TextBoolean";
import TextAmount from 'components/text/TextAmount';




const BondSetting = ({ data }) => {
  if (!data || Object.keys(data).length === 0){
    return (
      <div/>
    );
  }
  let setting = data;
  let title = 'Skuldabréfa stillingar';

  let legsRows = [
    {
      title : "Nafnverð",
      field : "amount",
      display : (data) => {         
        return (<TextAmount value={data}/>); 
      }
    },
    {
      title : "Skuldbreyting",
      field : "debtRestructureAmount",
      display : (data) => {         
        return (<TextAmount value={data}/>); 
      }
    },
    {
      title : "Tegund",
      field : "bondType",
      display : (data) => {         
        return (<BondType data={data.bondTypeID}/>); 
      }
    },
    {
      title : "Útgáfudagur",
      field : "issueDate",
      display : (data) => {         
        return (<TextDate value={data}/>); 
      }
    },
    {
      title : "Fyrsti gjalddagi",
      field : "firstPaymentDate",
      display : (data) => {         
        return (<TextDate value={data}/>); 
      }
    },
    {
      title : "Fyrstu vanskil",
      field : "firstNeglectPaymentDate",
      display : (data) => {         
        return (<TextDate value={data}/>); 
      }
    },
    {
      title : "Samningsvaxtadagur",
      field : "contractInterestDate",
      display : (data) => {         
        return (<TextDate value={data}/>); 
      }
    },    
    {
      title : "Verðtryggt",
      field : "indexInterestDate",
      display : (data) => {         
        if (data){        
          return (<TextDate value={data}/>); 
        }
        else{
          return (<TextBoolean value={false}/>);
        }
      }
    },   
    {
      title : "Fjöldi afborgana",
      field : "numberOfPayments",
      display : (data) => {         
        return (<TextAmount value={data}/>); 
      }
    },
    {
      title : "Vaxtaafborganir",
      field : "numberOfInterestPayments",
      display : (data) => {         
        return (<TextAmount value={data}/>); 
      }
    },
    {
      title : "Mánuðir á milli",
      field : "monthsBetweenPayments",
      display : (data) => {         
        return (<TextAmount value={data}/>); 
      }
    },
    {
      title : "Þynglýsingar dagur",
      field : "registerDate",
      display : (data) => {         
        return (<TextDate value={data}/>); 
      }
    },
    {
      title : "Greiðslujöfnun",
      field : "Equalization",
      display : (data) => {         
        return (<TextBoolean value={data}/>); 
      }
    },
    {
      title : "Greiðslujöfnunar dagur",
      field : "EqualizationStartDate",
      display : (data) => {         
        return (<TextDate value={data}/>); 
      }
    },
    {
      title : "Grunngreiðslumark",
      field : "EqualizationLimit",
      display : (data) => {         
        return (<TextAmount value={data}/>); 
      }
    },
    {
      title : "Eftirst. á jöfn. við fyrstu v.",
      field : "EqualizationRemainder",
      display : (data) => {         
        return (<TextAmount value={data}/>); 
      }
    },
  ];

  let rows = [
    {
      title : "Gjaldfellt",
      field : "calledIn",
      display : (data) => { return (<TextBoolean value={data}/>); }
    },
    {
      title : "Gjaldfellt vegna vanskila",
      field : "calledInBecauseOfDefault",
      display : (data) => { return (<TextBoolean value={data}/>); }
    },
    {
      title : "Gjaldfellingar dagur",
      field : "calledInDate",
      display : (data) => { return (<TextDate value={data}/>); }
    },
    {
      title : "Fyrstu vanskil",
      field : "firstNeglectPaymentDate",
      display : (data) => { return (<TextDate value={data}/>); }
    },
    {
      title : null,      
      field : "legs",
      display : (legData) => { 
        console.log("Leg data", legData);      
        return (   
          <div>
            {legData.map((item, index) => <InfoTable key={index} title={'Leggur 1'} rows={legsRows} data={item}/>)}
          </div>);
      }
    }, 
  ];

  return (    
      <InfoTable title={title} rows={rows} data={setting}/>    
  );
};

BondSetting.propTypes = {
  data: PropTypes.object,
};

export default BondSetting;
